import { useCallback, useState } from 'react';
import { addBreadcrumb } from '@sentry/react';

import { useConfiguration } from '@ocx-app/modules/configuration/useConfiguration';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useMembershipContext } from '@ocx/data-membership';

import { FreshdeskSupportWidget } from './feat/freshdesk/freshdesk-support-widget';
import { DevRevPlugSDK } from './feat/devrev/devrev-plug-sdk';

export const useSupportWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { config } = useConfiguration();
  const widgetConfiguration = config?.support?.widget;
  const isEnabled = !!widgetConfiguration?.enabled;
  const { membership } = useMembershipContext();

  const open = useCallback(async () => {
    if (!widgetConfiguration) {
      return;
    }
    setIsLoading(true);

    if (widgetConfiguration?.type === 'devrev_plug') {
      DevRevPlugSDK.open({
        app_id: widgetConfiguration.appId,
        enable_default_launcher: false,
        identity: membership?.id
          ? {
              user_ref: membership.id,
              user_traits: {
                // custom_fields: {
                //   tnt__version: config.version,
                // },
                display_name: `${membership.firstName ?? ''} ${membership.lastName ?? ''}`.trim(),
                email: membership.email ?? undefined,
                phone_numbers: membership.phone ? [membership.phone] : undefined,
              },
            }
          : null,
      })
        .catch((error) => {
          addBreadcrumb({ message: 'DevRevPlugSDK widget failed', data: { error } });
        })
        .finally(() => setIsLoading(false));
    }

    if (widgetConfiguration.type === 'freshdesk') {
      FreshdeskSupportWidget.open({
        token: widgetConfiguration.token,
        widgetUuid: widgetConfiguration.widgetId,
        host: widgetConfiguration.host,
        sdkUrl: widgetConfiguration.sdkUrl,
        firstName: membership?.firstName,
        lastName: membership?.lastName,
        email: membership?.email,
        externalId: membership?.id,
      })
        .catch((error) => {
          addBreadcrumb({ message: 'Freshdesk Support Widget failed', data: { error } });
        })
        .finally(() => setIsLoading(false));
    }
  }, [
    widgetConfiguration,
    membership?.id,
    membership?.firstName,
    membership?.lastName,
    membership?.email,
    membership?.phone,
  ]);

  return { isEnabled, isLoading, open };
};
